// src/axiosInterceptor.js
import axios from 'axios';
import { navigateTo } from './navigationUtils';

const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    response => response,
    error => {
      if (
        error.response &&
        (error.response.status === 401 || error.response.status === 403)
      ) {
        // Remove token from localStorage
        localStorage.removeItem('sassoontoken');
        // Redirect to login page using React Router
        navigateTo('/login');
      }
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;